// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
.pointer-events-none {
  pointer-events: none;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.static {
  position: static;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: calc(var(--spacing) * 0);
}
.inset-x-0 {
  inset-inline: calc(var(--spacing) * 0);
}
.start {
  inset-inline-start: var(--spacing);
}
.-top-2 {
  top: calc(var(--spacing) * -2);
}
.-top-10 {
  top: calc(var(--spacing) * -10);
}
.top-0 {
  top: calc(var(--spacing) * 0);
}
.top-4 {
  top: calc(var(--spacing) * 4);
}
.top-6 {
  top: calc(var(--spacing) * 6);
}
.top-28 {
  top: calc(var(--spacing) * 28);
}
.-right-2 {
  right: calc(var(--spacing) * -2);
}
.-right-10 {
  right: calc(var(--spacing) * -10);
}
.right-0 {
  right: calc(var(--spacing) * 0);
}
.right-4 {
  right: calc(var(--spacing) * 4);
}
.right-6 {
  right: calc(var(--spacing) * 6);
}
.right-8 {
  right: calc(var(--spacing) * 8);
}
.-bottom-2 {
  bottom: calc(var(--spacing) * -2);
}
.-bottom-6 {
  bottom: calc(var(--spacing) * -6);
}
.-bottom-10 {
  bottom: calc(var(--spacing) * -10);
}
.bottom-0 {
  bottom: calc(var(--spacing) * 0);
}
.bottom-6 {
  bottom: calc(var(--spacing) * 6);
}
.-left-6 {
  left: calc(var(--spacing) * -6);
}
.-left-10 {
  left: calc(var(--spacing) * -10);
}
.left-0 {
  left: calc(var(--spacing) * 0);
}
.left-1\\/2 {
  left: calc(1 / 2 * 100%);
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.container {
  width: 100%;
  @media (width >= 40rem) {
    max-width: 40rem;
  }
  @media (width >= 48rem) {
    max-width: 48rem;
  }
  @media (width >= 64rem) {
    max-width: 64rem;
  }
  @media (width >= 80rem) {
    max-width: 80rem;
  }
  @media (width >= 96rem) {
    max-width: 96rem;
  }
}
.mx-auto {
  margin-inline: auto;
}
.my-4 {
  margin-block: calc(var(--spacing) * 4);
}
.mt-1 {
  margin-top: calc(var(--spacing) * 1);
}
.mt-2 {
  margin-top: calc(var(--spacing) * 2);
}
.mt-3 {
  margin-top: calc(var(--spacing) * 3);
}
.mt-4 {
  margin-top: calc(var(--spacing) * 4);
}
.mt-5 {
  margin-top: calc(var(--spacing) * 5);
}
.mt-6 {
  margin-top: calc(var(--spacing) * 6);
}
.mt-8 {
  margin-top: calc(var(--spacing) * 8);
}
.mt-10 {
  margin-top: calc(var(--spacing) * 10);
}
.mt-12 {
  margin-top: calc(var(--spacing) * 12);
}
.mt-14 {
  margin-top: calc(var(--spacing) * 14);
}
.mt-16 {
  margin-top: calc(var(--spacing) * 16);
}
.mb-1 {
  margin-bottom: calc(var(--spacing) * 1);
}
.mb-2 {
  margin-bottom: calc(var(--spacing) * 2);
}
.mb-3 {
  margin-bottom: calc(var(--spacing) * 3);
}
.mb-4 {
  margin-bottom: calc(var(--spacing) * 4);
}
.mb-5 {
  margin-bottom: calc(var(--spacing) * 5);
}
.mb-6 {
  margin-bottom: calc(var(--spacing) * 6);
}
.mb-8 {
  margin-bottom: calc(var(--spacing) * 8);
}
.mb-10 {
  margin-bottom: calc(var(--spacing) * 10);
}
.mb-12 {
  margin-bottom: calc(var(--spacing) * 12);
}
.mb-14 {
  margin-bottom: calc(var(--spacing) * 14);
}
.mb-16 {
  margin-bottom: calc(var(--spacing) * 16);
}
.ml-4 {
  margin-left: calc(var(--spacing) * 4);
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.inline {
  display: inline;
}
.inline-block {
  display: inline-block;
}
.inline-flex {
  display: inline-flex;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-\\[4\\/5\\] {
  aspect-ratio: 4/5;
}
.h-1\\.5 {
  height: calc(var(--spacing) * 1.5);
}
.h-3 {
  height: calc(var(--spacing) * 3);
}
.h-3\\.5 {
  height: calc(var(--spacing) * 3.5);
}
.h-4 {
  height: calc(var(--spacing) * 4);
}
.h-5 {
  height: calc(var(--spacing) * 5);
}
.h-6 {
  height: calc(var(--spacing) * 6);
}
.h-7 {
  height: calc(var(--spacing) * 7);
}
.h-8 {
  height: calc(var(--spacing) * 8);
}
.h-11 {
  height: calc(var(--spacing) * 11);
}
.h-12 {
  height: calc(var(--spacing) * 12);
}
.h-14 {
  height: calc(var(--spacing) * 14);
}
.h-16 {
  height: calc(var(--spacing) * 16);
}
.h-20 {
  height: calc(var(--spacing) * 20);
}
.h-32 {
  height: calc(var(--spacing) * 32);
}
.h-40 {
  height: calc(var(--spacing) * 40);
}
.h-48 {
  height: calc(var(--spacing) * 48);
}
.h-\\[35dvh\\] {
  height: 35dvh;
}
.h-\\[40vh\\] {
  height: 40vh;
}
.h-\\[46dvh\\] {
  height: 46dvh;
}
.h-\\[50vh\\] {
  height: 50vh;
}
.h-\\[60dvh\\] {
  height: 60dvh;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[90dvh\\] {
  height: 90dvh;
}
.h-full {
  height: 100%;
}
.max-h-0 {
  max-height: calc(var(--spacing) * 0);
}
.max-h-96 {
  max-height: calc(var(--spacing) * 96);
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[320px\\] {
  min-height: 320px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-dvh {
  min-height: 100dvh;
}
.w-1\\.5 {
  width: calc(var(--spacing) * 1.5);
}
.w-2\\/3 {
  width: calc(2 / 3 * 100%);
}
.w-3 {
  width: calc(var(--spacing) * 3);
}
.w-3\\.5 {
  width: calc(var(--spacing) * 3.5);
}
.w-3\\/4 {
  width: calc(3 / 4 * 100%);
}
.w-4 {
  width: calc(var(--spacing) * 4);
}
.w-5 {
  width: calc(var(--spacing) * 5);
}
.w-5\\/6 {
  width: calc(5 / 6 * 100%);
}
.w-6 {
  width: calc(var(--spacing) * 6);
}
.w-7 {
  width: calc(var(--spacing) * 7);
}
.w-8 {
  width: calc(var(--spacing) * 8);
}
.w-11 {
  width: calc(var(--spacing) * 11);
}
.w-12 {
  width: calc(var(--spacing) * 12);
}
.w-14 {
  width: calc(var(--spacing) * 14);
}
.w-16 {
  width: calc(var(--spacing) * 16);
}
.w-20 {
  width: calc(var(--spacing) * 20);
}
.w-24 {
  width: calc(var(--spacing) * 24);
}
.w-32 {
  width: calc(var(--spacing) * 32);
}
.w-40 {
  width: calc(var(--spacing) * 40);
}
.w-80 {
  width: calc(var(--spacing) * 80);
}
.w-full {
  width: 100%;
}
.max-w-2xl {
  max-width: var(--container-2xl);
}
.max-w-3xl {
  max-width: var(--container-3xl);
}
.max-w-4xl {
  max-width: var(--container-4xl);
}
.max-w-7xl {
  max-width: var(--container-7xl);
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-lg {
  max-width: var(--container-lg);
}
.max-w-none {
  max-width: none;
}
.max-w-xl {
  max-width: var(--container-xl);
}
.flex-1 {
  flex: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.-translate-x-1\\/2 {
  --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
  translate: var(--tw-translate-x) var(--tw-translate-y);
}
.translate-y-0 {
  --tw-translate-y: calc(var(--spacing) * 0);
  translate: var(--tw-translate-x) var(--tw-translate-y);
}
.translate-y-2 {
  --tw-translate-y: calc(var(--spacing) * 2);
  translate: var(--tw-translate-x) var(--tw-translate-y);
}
.translate-y-3 {
  --tw-translate-y: calc(var(--spacing) * 3);
  translate: var(--tw-translate-x) var(--tw-translate-y);
}
.translate-y-4 {
  --tw-translate-y: calc(var(--spacing) * 4);
  translate: var(--tw-translate-x) var(--tw-translate-y);
}
.rotate-45 {
  rotate: 45deg;
}
.transform {
  transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
}
.animate-pulse {
  animation: var(--animate-pulse);
}
.animate-spin {
  animation: var(--animate-spin);
}
.resize-none {
  resize: none;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-center {
  align-items: center;
}
.items-end {
  align-items: flex-end;
}
.items-start {
  align-items: flex-start;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.gap-1\\.5 {
  gap: calc(var(--spacing) * 1.5);
}
.gap-2 {
  gap: calc(var(--spacing) * 2);
}
.gap-3 {
  gap: calc(var(--spacing) * 3);
}
.gap-4 {
  gap: calc(var(--spacing) * 4);
}
.gap-5 {
  gap: calc(var(--spacing) * 5);
}
.gap-6 {
  gap: calc(var(--spacing) * 6);
}
.gap-7 {
  gap: calc(var(--spacing) * 7);
}
.gap-8 {
  gap: calc(var(--spacing) * 8);
}
.gap-10 {
  gap: calc(var(--spacing) * 10);
}
.gap-12 {
  gap: calc(var(--spacing) * 12);
}
.space-y-1 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-2 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-3 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-4 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-5 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 5) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 5) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.space-y-6 {
  :where(& > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
  }
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: var(--radius-2xl);
}
.rounded-3xl {
  border-radius: var(--radius-3xl);
}
.rounded-\\[18px\\] {
  border-radius: 18px;
}
.rounded-\\[22px\\] {
  border-radius: 22px;
}
.rounded-full {
  border-radius: calc(infinity * 1px);
}
.rounded-lg {
  border-radius: var(--radius-lg);
}
.rounded-xl {
  border-radius: var(--radius-xl);
}
.border {
  border-style: var(--tw-border-style);
  border-width: 1px;
}
.border-2 {
  border-style: var(--tw-border-style);
  border-width: 2px;
}
.border-t {
  border-top-style: var(--tw-border-style);
  border-top-width: 1px;
}
.border-b {
  border-bottom-style: var(--tw-border-style);
  border-bottom-width: 1px;
}
.border-blue-200 {
  border-color: var(--color-blue-200);
}
.border-emerald-200 {
  border-color: var(--color-emerald-200);
}
.border-emerald-700 {
  border-color: var(--color-emerald-700);
}
.border-emerald-900\\/10 {
  border-color: color-mix(in srgb, oklch(37.8% 0.077 168.94) 10%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    border-color: color-mix(in oklab, var(--color-emerald-900) 10%, transparent);
  }
}
.border-gray-100 {
  border-color: var(--color-gray-100);
}
.border-gray-200 {
  border-color: var(--color-gray-200);
}
.border-gray-600 {
  border-color: var(--color-gray-600);
}
.border-red-200 {
  border-color: var(--color-red-200);
}
.border-white {
  border-color: var(--color-white);
}
.border-white\\/10 {
  border-color: color-mix(in srgb, #fff 10%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    border-color: color-mix(in oklab, var(--color-white) 10%, transparent);
  }
}
.bg-\\[\\#25D366\\] {
  background-color: #25D366;
}
.bg-\\[\\#C9A227\\] {
  background-color: #C9A227;
}
.bg-\\[\\#C9A227\\]\\/10 {
  background-color: color-mix(in oklab, #C9A227 10%, transparent);
}
.bg-\\[\\#F7F1EC\\] {
  background-color: #F7F1EC;
}
.bg-amber-50 {
  background-color: var(--color-amber-50);
}
.bg-amber-100 {
  background-color: var(--color-amber-100);
}
.bg-amber-900 {
  background-color: var(--color-amber-900);
}
.bg-black\\/40 {
  background-color: color-mix(in srgb, #000 40%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-black) 40%, transparent);
  }
}
.bg-blue-50 {
  background-color: var(--color-blue-50);
}
.bg-emerald-50 {
  background-color: var(--color-emerald-50);
}
.bg-emerald-100 {
  background-color: var(--color-emerald-100);
}
.bg-emerald-600 {
  background-color: var(--color-emerald-600);
}
.bg-emerald-600\\/10 {
  background-color: color-mix(in srgb, oklch(59.6% 0.145 163.225) 10%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-emerald-600) 10%, transparent);
  }
}
.bg-emerald-600\\/20 {
  background-color: color-mix(in srgb, oklch(59.6% 0.145 163.225) 20%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-emerald-600) 20%, transparent);
  }
}
.bg-emerald-700 {
  background-color: var(--color-emerald-700);
}
.bg-emerald-800 {
  background-color: var(--color-emerald-800);
}
.bg-emerald-900 {
  background-color: var(--color-emerald-900);
}
.bg-gray-50 {
  background-color: var(--color-gray-50);
}
.bg-gray-100 {
  background-color: var(--color-gray-100);
}
.bg-gray-200 {
  background-color: var(--color-gray-200);
}
.bg-gray-900 {
  background-color: var(--color-gray-900);
}
.bg-gray-950 {
  background-color: var(--color-gray-950);
}
.bg-red-50 {
  background-color: var(--color-red-50);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  background-color: var(--color-white);
}
.bg-white\\/5 {
  background-color: color-mix(in srgb, #fff 5%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
  }
}
.bg-white\\/10 {
  background-color: color-mix(in srgb, #fff 10%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
  }
}
.bg-white\\/20 {
  background-color: color-mix(in srgb, #fff 20%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-white) 20%, transparent);
  }
}
.bg-white\\/90 {
  background-color: color-mix(in srgb, #fff 90%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-white) 90%, transparent);
  }
}
.bg-white\\/95 {
  background-color: color-mix(in srgb, #fff 95%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-white) 95%, transparent);
  }
}
.bg-gradient-to-b {
  --tw-gradient-position: to bottom in oklab;
  background-image: linear-gradient(var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  --tw-gradient-position: to bottom right in oklab;
  background-image: linear-gradient(var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  --tw-gradient-position: to right in oklab;
  background-image: linear-gradient(var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  --tw-gradient-position: to top in oklab;
  background-image: linear-gradient(var(--tw-gradient-stops));
}
.from-black\\/20 {
  --tw-gradient-from: color-mix(in srgb, #000 20%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-from: color-mix(in oklab, var(--color-black) 20%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.from-black\\/40 {
  --tw-gradient-from: color-mix(in srgb, #000 40%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-from: color-mix(in oklab, var(--color-black) 40%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.from-black\\/45 {
  --tw-gradient-from: color-mix(in srgb, #000 45%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-from: color-mix(in oklab, var(--color-black) 45%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.from-black\\/50 {
  --tw-gradient-from: color-mix(in srgb, #000 50%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-from: color-mix(in oklab, var(--color-black) 50%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.from-black\\/60 {
  --tw-gradient-from: color-mix(in srgb, #000 60%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-from: color-mix(in oklab, var(--color-black) 60%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.from-emerald-50 {
  --tw-gradient-from: var(--color-emerald-50);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.from-emerald-100 {
  --tw-gradient-from: var(--color-emerald-100);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.from-emerald-900 {
  --tw-gradient-from: var(--color-emerald-900);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.via-black\\/15 {
  --tw-gradient-via: color-mix(in srgb, #000 15%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-via: color-mix(in oklab, var(--color-black) 15%, transparent);
  }
  --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-via-stops);
}
.via-black\\/20 {
  --tw-gradient-via: color-mix(in srgb, #000 20%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-via: color-mix(in oklab, var(--color-black) 20%, transparent);
  }
  --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-via-stops);
}
.via-black\\/30 {
  --tw-gradient-via: color-mix(in srgb, #000 30%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-via: color-mix(in oklab, var(--color-black) 30%, transparent);
  }
  --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-via-stops);
}
.via-black\\/40 {
  --tw-gradient-via: color-mix(in srgb, #000 40%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-via: color-mix(in oklab, var(--color-black) 40%, transparent);
  }
  --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-via-stops);
}
.via-emerald-800 {
  --tw-gradient-via: var(--color-emerald-800);
  --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-via-stops);
}
.via-transparent {
  --tw-gradient-via: transparent;
  --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-via-stops);
}
.to-black\\/40 {
  --tw-gradient-to: color-mix(in srgb, #000 40%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-to: color-mix(in oklab, var(--color-black) 40%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-black\\/60 {
  --tw-gradient-to: color-mix(in srgb, #000 60%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-to: color-mix(in oklab, var(--color-black) 60%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-emerald-50 {
  --tw-gradient-to: var(--color-emerald-50);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-emerald-50\\/50 {
  --tw-gradient-to: color-mix(in srgb, oklch(97.9% 0.021 166.113) 50%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-gradient-to: color-mix(in oklab, var(--color-emerald-50) 50%, transparent);
  }
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-emerald-900 {
  --tw-gradient-to: var(--color-emerald-900);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-gray-950 {
  --tw-gradient-to: var(--color-gray-950);
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.to-transparent {
  --tw-gradient-to: transparent;
  --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
}
.object-cover {
  object-fit: cover;
}
.p-1 {
  padding: calc(var(--spacing) * 1);
}
.p-2 {
  padding: calc(var(--spacing) * 2);
}
.p-4 {
  padding: calc(var(--spacing) * 4);
}
.p-6 {
  padding: calc(var(--spacing) * 6);
}
.p-8 {
  padding: calc(var(--spacing) * 8);
}
.p-12 {
  padding: calc(var(--spacing) * 12);
}
.px-1\\.5 {
  padding-inline: calc(var(--spacing) * 1.5);
}
.px-4 {
  padding-inline: calc(var(--spacing) * 4);
}
.px-5 {
  padding-inline: calc(var(--spacing) * 5);
}
.px-6 {
  padding-inline: calc(var(--spacing) * 6);
}
.px-8 {
  padding-inline: calc(var(--spacing) * 8);
}
.py-0\\.5 {
  padding-block: calc(var(--spacing) * 0.5);
}
.py-2 {
  padding-block: calc(var(--spacing) * 2);
}
.py-2\\.5 {
  padding-block: calc(var(--spacing) * 2.5);
}
.py-3 {
  padding-block: calc(var(--spacing) * 3);
}
.py-3\\.5 {
  padding-block: calc(var(--spacing) * 3.5);
}
.py-4 {
  padding-block: calc(var(--spacing) * 4);
}
.py-6 {
  padding-block: calc(var(--spacing) * 6);
}
.py-12 {
  padding-block: calc(var(--spacing) * 12);
}
.py-16 {
  padding-block: calc(var(--spacing) * 16);
}
.py-20 {
  padding-block: calc(var(--spacing) * 20);
}
.pt-8 {
  padding-top: calc(var(--spacing) * 8);
}
.pt-12 {
  padding-top: calc(var(--spacing) * 12);
}
.pr-6 {
  padding-right: calc(var(--spacing) * 6);
}
.pr-12 {
  padding-right: calc(var(--spacing) * 12);
}
.pb-6 {
  padding-bottom: calc(var(--spacing) * 6);
}
.pb-12 {
  padding-bottom: calc(var(--spacing) * 12);
}
.pl-4 {
  padding-left: calc(var(--spacing) * 4);
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.font-mono {
  font-family: var(--font-mono);
}
.font-serif {
  font-family: var(--font-serif);
}
.text-2xl {
  font-size: var(--text-2xl);
  line-height: var(--tw-leading, var(--text-2xl--line-height));
}
.text-3xl {
  font-size: var(--text-3xl);
  line-height: var(--tw-leading, var(--text-3xl--line-height));
}
.text-4xl {
  font-size: var(--text-4xl);
  line-height: var(--tw-leading, var(--text-4xl--line-height));
}
.text-base {
  font-size: var(--text-base);
  line-height: var(--tw-leading, var(--text-base--line-height));
}
.text-lg {
  font-size: var(--text-lg);
  line-height: var(--tw-leading, var(--text-lg--line-height));
}
.text-sm {
  font-size: var(--text-sm);
  line-height: var(--tw-leading, var(--text-sm--line-height));
}
.text-xl {
  font-size: var(--text-xl);
  line-height: var(--tw-leading, var(--text-xl--line-height));
}
.text-xs {
  font-size: var(--text-xs);
  line-height: var(--tw-leading, var(--text-xs--line-height));
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[48px\\] {
  font-size: 48px;
}
.leading-\\[1\\.1\\] {
  --tw-leading: 1.1;
  line-height: 1.1;
}
.leading-relaxed {
  --tw-leading: var(--leading-relaxed);
  line-height: var(--leading-relaxed);
}
.leading-tight {
  --tw-leading: var(--leading-tight);
  line-height: var(--leading-tight);
}
.font-bold {
  --tw-font-weight: var(--font-weight-bold);
  font-weight: var(--font-weight-bold);
}
.font-light {
  --tw-font-weight: var(--font-weight-light);
  font-weight: var(--font-weight-light);
}
.font-medium {
  --tw-font-weight: var(--font-weight-medium);
  font-weight: var(--font-weight-medium);
}
.font-semibold {
  --tw-font-weight: var(--font-weight-semibold);
  font-weight: var(--font-weight-semibold);
}
.tracking-\\[\\.12em\\] {
  --tw-tracking: .12em;
  letter-spacing: .12em;
}
.tracking-\\[0\\.2em\\] {
  --tw-tracking: 0.2em;
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.25em\\] {
  --tw-tracking: 0.25em;
  letter-spacing: 0.25em;
}
.tracking-\\[0\\.35em\\] {
  --tw-tracking: 0.35em;
  letter-spacing: 0.35em;
}
.tracking-wide {
  --tw-tracking: var(--tracking-wide);
  letter-spacing: var(--tracking-wide);
}
.tracking-wider {
  --tw-tracking: var(--tracking-wider);
  letter-spacing: var(--tracking-wider);
}
.tracking-widest {
  --tw-tracking: var(--tracking-widest);
  letter-spacing: var(--tracking-widest);
}
.text-\\[\\#C9A227\\] {
  color: #C9A227;
}
.text-amber-100 {
  color: var(--color-amber-100);
}
.text-amber-600 {
  color: var(--color-amber-600);
}
.text-amber-700 {
  color: var(--color-amber-700);
}
.text-blue-500 {
  color: var(--color-blue-500);
}
.text-emerald-100 {
  color: var(--color-emerald-100);
}
.text-emerald-200 {
  color: var(--color-emerald-200);
}
.text-emerald-400 {
  color: var(--color-emerald-400);
}
.text-emerald-500 {
  color: var(--color-emerald-500);
}
.text-emerald-600 {
  color: var(--color-emerald-600);
}
.text-emerald-700 {
  color: var(--color-emerald-700);
}
.text-emerald-800 {
  color: var(--color-emerald-800);
}
.text-emerald-900 {
  color: var(--color-emerald-900);
}
.text-gray-100 {
  color: var(--color-gray-100);
}
.text-gray-300 {
  color: var(--color-gray-300);
}
.text-gray-400 {
  color: var(--color-gray-400);
}
.text-gray-500 {
  color: var(--color-gray-500);
}
.text-gray-600 {
  color: var(--color-gray-600);
}
.text-gray-700 {
  color: var(--color-gray-700);
}
.text-gray-800 {
  color: var(--color-gray-800);
}
.text-gray-900 {
  color: var(--color-gray-900);
}
.text-red-400 {
  color: var(--color-red-400);
}
.text-red-500 {
  color: var(--color-red-500);
}
.text-red-700 {
  color: var(--color-red-700);
}
.text-white {
  color: var(--color-white);
}
.text-white\\/80 {
  color: color-mix(in srgb, #fff 80%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-white) 80%, transparent);
  }
}
.text-white\\/90 {
  color: color-mix(in srgb, #fff 90%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    color: color-mix(in oklab, var(--color-white) 90%, transparent);
  }
}
.uppercase {
  text-transform: uppercase;
}
.underline {
  text-decoration-line: underline;
}
.decoration-emerald-300 {
  text-decoration-color: var(--color-emerald-300);
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.opacity-0 {
  opacity: 0%;
}
.opacity-70 {
  opacity: 70%;
}
.opacity-90 {
  opacity: 90%;
}
.opacity-100 {
  opacity: 100%;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_-12px_rgba\\(0\\,0\\,0\\,0\\.2\\)\\] {
  --tw-shadow: 0 10px 30px -12px var(--tw-shadow-color, rgba(0,0,0,0.2));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_-12px_rgba\\(0\\,0\\,0\\,0\\.35\\)\\] {
  --tw-shadow: 0 10px 30px -12px var(--tw-shadow-color, rgba(0,0,0,0.35));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-\\[0_18px_38px_-14px_rgba\\(0\\,0\\,0\\,0\\.35\\)\\] {
  --tw-shadow: 0 18px 38px -14px var(--tw-shadow-color, rgba(0,0,0,0.35));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-12px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\] {
  --tw-shadow: 0 20px 50px -12px var(--tw-shadow-color, rgba(0,0,0,0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-12px_rgba\\(0\\,0\\,0\\,0\\.15\\)\\] {
  --tw-shadow: 0 20px 50px -12px var(--tw-shadow-color, rgba(0,0,0,0.15));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.shadow-\\[\\#C9A227\\]\\/30 {
  --tw-shadow-color: color-mix(in srgb, #C9A227 30%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, #C9A227 30%, transparent) var(--tw-shadow-alpha), transparent);
  }
}
.shadow-emerald-700\\/25 {
  --tw-shadow-color: color-mix(in srgb, oklch(50.8% 0.118 165.612) 25%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-emerald-700) 25%, transparent) var(--tw-shadow-alpha), transparent);
  }
}
.shadow-emerald-700\\/30 {
  --tw-shadow-color: color-mix(in srgb, oklch(50.8% 0.118 165.612) 30%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, var(--color-emerald-700) 30%, transparent) var(--tw-shadow-alpha), transparent);
  }
}
.drop-shadow-\\[0_2px_4px_rgba\\(0\\,0\\,0\\,0\\.5\\)\\] {
  --tw-drop-shadow-size: drop-shadow(0 2px 4px var(--tw-drop-shadow-color, rgba(0,0,0,0.5)));
  --tw-drop-shadow: var(--tw-drop-shadow-size);
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
}
.drop-shadow-lg {
  --tw-drop-shadow-size: drop-shadow(0 4px 4px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.15)));
  --tw-drop-shadow: drop-shadow(var(--drop-shadow-lg));
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
}
.drop-shadow-md {
  --tw-drop-shadow-size: drop-shadow(0 3px 3px var(--tw-drop-shadow-color, rgb(0 0 0 / 0.12)));
  --tw-drop-shadow: drop-shadow(var(--drop-shadow-md));
  filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(var(--blur-md));
  backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(var(--blur-sm));
  backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
}
.transition {
  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.transition-all {
  transition-property: all;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.transition-colors {
  transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.transition-transform {
  transition-property: transform, translate, scale, rotate;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
  transition-duration: var(--tw-duration, var(--default-transition-duration));
}
.duration-300 {
  --tw-duration: 300ms;
  transition-duration: 300ms;
}
.duration-500 {
  --tw-duration: 500ms;
  transition-duration: 500ms;
}
.duration-700 {
  --tw-duration: 700ms;
  transition-duration: 700ms;
}
.ease-in-out {
  --tw-ease: var(--ease-in-out);
  transition-timing-function: var(--ease-in-out);
}
.group-hover\\:scale-105 {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      --tw-scale-x: 105%;
      --tw-scale-y: 105%;
      --tw-scale-z: 105%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
}
.group-hover\\:scale-110 {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      --tw-scale-x: 110%;
      --tw-scale-y: 110%;
      --tw-scale-z: 110%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
}
.group-hover\\:scale-\\[1\\.04\\] {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      scale: 1.04;
    }
  }
}
.group-hover\\:scale-\\[1\\.05\\] {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      scale: 1.05;
    }
  }
}
.group-hover\\:bg-emerald-200 {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      background-color: var(--color-emerald-200);
    }
  }
}
.group-hover\\:bg-white {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      background-color: var(--color-white);
    }
  }
}
.group-hover\\:text-\\[\\#B8860B\\] {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      color: #B8860B;
    }
  }
}
.group-hover\\:text-emerald-700 {
  &:is(:where(.group):hover *) {
    @media (hover: hover) {
      color: var(--color-emerald-700);
    }
  }
}
.last\\:border-b-0 {
  &:last-child {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
}
.hover\\:translate-x-1 {
  &:hover {
    @media (hover: hover) {
      --tw-translate-x: calc(var(--spacing) * 1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
}
.hover\\:-translate-y-0\\.5 {
  &:hover {
    @media (hover: hover) {
      --tw-translate-y: calc(var(--spacing) * -0.5);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
}
.hover\\:-translate-y-1 {
  &:hover {
    @media (hover: hover) {
      --tw-translate-y: calc(var(--spacing) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
}
.hover\\:scale-110 {
  &:hover {
    @media (hover: hover) {
      --tw-scale-x: 110%;
      --tw-scale-y: 110%;
      --tw-scale-z: 110%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
}
.hover\\:border-gray-500 {
  &:hover {
    @media (hover: hover) {
      border-color: var(--color-gray-500);
    }
  }
}
.hover\\:bg-\\[\\#20BD5A\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #20BD5A;
    }
  }
}
.hover\\:bg-\\[\\#B8860B\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #B8860B;
    }
  }
}
.hover\\:bg-\\[\\#C9A227\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #C9A227;
    }
  }
}
.hover\\:bg-emerald-50 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-emerald-50);
    }
  }
}
.hover\\:bg-emerald-100 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-emerald-100);
    }
  }
}
.hover\\:bg-emerald-700 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-emerald-700);
    }
  }
}
.hover\\:bg-emerald-800 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-emerald-800);
    }
  }
}
.hover\\:bg-gray-50 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-50);
    }
  }
}
.hover\\:bg-gray-200 {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-200);
    }
  }
}
.hover\\:bg-white {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-white);
    }
  }
}
.hover\\:from-emerald-100 {
  &:hover {
    @media (hover: hover) {
      --tw-gradient-from: var(--color-emerald-100);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
  }
}
.hover\\:to-emerald-50 {
  &:hover {
    @media (hover: hover) {
      --tw-gradient-to: var(--color-emerald-50);
      --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
    }
  }
}
.hover\\:text-\\[\\#C9A227\\] {
  &:hover {
    @media (hover: hover) {
      color: #C9A227;
    }
  }
}
.hover\\:text-\\[\\#D4AF37\\] {
  &:hover {
    @media (hover: hover) {
      color: #D4AF37;
    }
  }
}
.hover\\:text-amber-900 {
  &:hover {
    @media (hover: hover) {
      color: var(--color-amber-900);
    }
  }
}
.hover\\:text-emerald-700 {
  &:hover {
    @media (hover: hover) {
      color: var(--color-emerald-700);
    }
  }
}
.hover\\:text-emerald-800 {
  &:hover {
    @media (hover: hover) {
      color: var(--color-emerald-800);
    }
  }
}
.hover\\:text-emerald-900 {
  &:hover {
    @media (hover: hover) {
      color: var(--color-emerald-900);
    }
  }
}
.hover\\:text-gray-300 {
  &:hover {
    @media (hover: hover) {
      color: var(--color-gray-300);
    }
  }
}
.hover\\:text-gray-600 {
  &:hover {
    @media (hover: hover) {
      color: var(--color-gray-600);
    }
  }
}
.hover\\:text-red-800 {
  &:hover {
    @media (hover: hover) {
      color: var(--color-red-800);
    }
  }
}
.hover\\:text-white {
  &:hover {
    @media (hover: hover) {
      color: var(--color-white);
    }
  }
}
.hover\\:underline {
  &:hover {
    @media (hover: hover) {
      text-decoration-line: underline;
    }
  }
}
.hover\\:decoration-emerald-700 {
  &:hover {
    @media (hover: hover) {
      text-decoration-color: var(--color-emerald-700);
    }
  }
}
.hover\\:opacity-100 {
  &:hover {
    @media (hover: hover) {
      opacity: 100%;
    }
  }
}
.hover\\:shadow-\\[0_15px_40px_-12px_rgba\\(0\\,0\\,0\\,0\\.3\\)\\] {
  &:hover {
    @media (hover: hover) {
      --tw-shadow: 0 15px 40px -12px var(--tw-shadow-color, rgba(0,0,0,0.3));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
}
.hover\\:shadow-lg {
  &:hover {
    @media (hover: hover) {
      --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
}
.hover\\:shadow-xl {
  &:hover {
    @media (hover: hover) {
      --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
}
.hover\\:shadow-\\[\\#25D366\\]\\/30 {
  &:hover {
    @media (hover: hover) {
      --tw-shadow-color: color-mix(in srgb, #25D366 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-shadow-color: color-mix(in oklab, color-mix(in oklab, #25D366 30%, transparent) var(--tw-shadow-alpha), transparent);
      }
    }
  }
}
.focus\\:border-emerald-500 {
  &:focus {
    border-color: var(--color-emerald-500);
  }
}
.focus\\:bg-white {
  &:focus {
    background-color: var(--color-white);
  }
}
.focus\\:ring-2 {
  &:focus {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
}
.focus\\:ring-emerald-500\\/20 {
  &:focus {
    --tw-ring-color: color-mix(in srgb, oklch(69.6% 0.17 162.48) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-emerald-500) 20%, transparent);
    }
  }
}
.focus\\:outline-none {
  &:focus {
    --tw-outline-style: none;
    outline-style: none;
  }
}
.focus-visible\\:ring-2 {
  &:focus-visible {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
}
.focus-visible\\:ring-\\[\\#C9A227\\] {
  &:focus-visible {
    --tw-ring-color: #C9A227;
  }
}
.focus-visible\\:ring-emerald-600 {
  &:focus-visible {
    --tw-ring-color: var(--color-emerald-600);
  }
}
.focus-visible\\:ring-gray-400 {
  &:focus-visible {
    --tw-ring-color: var(--color-gray-400);
  }
}
.focus-visible\\:ring-offset-2 {
  &:focus-visible {
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
}
.focus-visible\\:outline-none {
  &:focus-visible {
    --tw-outline-style: none;
    outline-style: none;
  }
}
.disabled\\:cursor-not-allowed {
  &:disabled {
    cursor: not-allowed;
  }
}
.disabled\\:opacity-50 {
  &:disabled {
    opacity: 50%;
  }
}
.disabled\\:opacity-60 {
  &:disabled {
    opacity: 60%;
  }
}
.disabled\\:hover\\:translate-y-0 {
  &:disabled {
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * 0);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
  }
}
.sm\\:inline {
  @media (width >= 40rem) {
    display: inline;
  }
}
.sm\\:grid-cols-2 {
  @media (width >= 40rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.sm\\:grid-cols-3 {
  @media (width >= 40rem) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.sm\\:flex-row {
  @media (width >= 40rem) {
    flex-direction: row;
  }
}
.sm\\:items-center {
  @media (width >= 40rem) {
    align-items: center;
  }
}
.sm\\:justify-between {
  @media (width >= 40rem) {
    justify-content: space-between;
  }
}
.sm\\:p-6 {
  @media (width >= 40rem) {
    padding: calc(var(--spacing) * 6);
  }
}
.sm\\:p-8 {
  @media (width >= 40rem) {
    padding: calc(var(--spacing) * 8);
  }
}
.sm\\:px-6 {
  @media (width >= 40rem) {
    padding-inline: calc(var(--spacing) * 6);
  }
}
.md\\:order-1 {
  @media (width >= 48rem) {
    order: 1;
  }
}
.md\\:order-2 {
  @media (width >= 48rem) {
    order: 2;
  }
}
.md\\:col-span-5 {
  @media (width >= 48rem) {
    grid-column: span 5 / span 5;
  }
}
.md\\:col-span-7 {
  @media (width >= 48rem) {
    grid-column: span 7 / span 7;
  }
}
.md\\:h-5 {
  @media (width >= 48rem) {
    height: calc(var(--spacing) * 5);
  }
}
.md\\:w-5 {
  @media (width >= 48rem) {
    width: calc(var(--spacing) * 5);
  }
}
.md\\:grid-cols-2 {
  @media (width >= 48rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.md\\:grid-cols-3 {
  @media (width >= 48rem) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.md\\:grid-cols-5 {
  @media (width >= 48rem) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
.md\\:grid-cols-12 {
  @media (width >= 48rem) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
.md\\:gap-3 {
  @media (width >= 48rem) {
    gap: calc(var(--spacing) * 3);
  }
}
.md\\:gap-14 {
  @media (width >= 48rem) {
    gap: calc(var(--spacing) * 14);
  }
}
.md\\:gap-16 {
  @media (width >= 48rem) {
    gap: calc(var(--spacing) * 16);
  }
}
.md\\:p-10 {
  @media (width >= 48rem) {
    padding: calc(var(--spacing) * 10);
  }
}
.md\\:p-12 {
  @media (width >= 48rem) {
    padding: calc(var(--spacing) * 12);
  }
}
.md\\:p-14 {
  @media (width >= 48rem) {
    padding: calc(var(--spacing) * 14);
  }
}
.md\\:px-6 {
  @media (width >= 48rem) {
    padding-inline: calc(var(--spacing) * 6);
  }
}
.md\\:py-24 {
  @media (width >= 48rem) {
    padding-block: calc(var(--spacing) * 24);
  }
}
.md\\:py-28 {
  @media (width >= 48rem) {
    padding-block: calc(var(--spacing) * 28);
  }
}
.md\\:text-2xl {
  @media (width >= 48rem) {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
}
.md\\:text-3xl {
  @media (width >= 48rem) {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
}
.md\\:text-4xl {
  @media (width >= 48rem) {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
}
.md\\:text-5xl {
  @media (width >= 48rem) {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
}
.md\\:text-base {
  @media (width >= 48rem) {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
}
.md\\:text-lg {
  @media (width >= 48rem) {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
}
.md\\:text-sm {
  @media (width >= 48rem) {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
}
.md\\:text-xl {
  @media (width >= 48rem) {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
}
.md\\:text-\\[36px\\] {
  @media (width >= 48rem) {
    font-size: 36px;
  }
}
.md\\:text-\\[40px\\] {
  @media (width >= 48rem) {
    font-size: 40px;
  }
}
.md\\:text-\\[44px\\] {
  @media (width >= 48rem) {
    font-size: 44px;
  }
}
.md\\:text-\\[48px\\] {
  @media (width >= 48rem) {
    font-size: 48px;
  }
}
.md\\:text-\\[80px\\] {
  @media (width >= 48rem) {
    font-size: 80px;
  }
}
.lg\\:order-1 {
  @media (width >= 64rem) {
    order: 1;
  }
}
.lg\\:order-2 {
  @media (width >= 64rem) {
    order: 2;
  }
}
.lg\\:col-span-1 {
  @media (width >= 64rem) {
    grid-column: span 1 / span 1;
  }
}
.lg\\:col-span-2 {
  @media (width >= 64rem) {
    grid-column: span 2 / span 2;
  }
}
.lg\\:flex {
  @media (width >= 64rem) {
    display: flex;
  }
}
.lg\\:hidden {
  @media (width >= 64rem) {
    display: none;
  }
}
.lg\\:grid-cols-2 {
  @media (width >= 64rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.lg\\:grid-cols-3 {
  @media (width >= 64rem) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.lg\\:grid-cols-4 {
  @media (width >= 64rem) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.lg\\:grid-cols-10 {
  @media (width >= 64rem) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
}
.lg\\:gap-16 {
  @media (width >= 64rem) {
    gap: calc(var(--spacing) * 16);
  }
}
.lg\\:px-12 {
  @media (width >= 64rem) {
    padding-inline: calc(var(--spacing) * 12);
  }
}
.lg\\:py-16 {
  @media (width >= 64rem) {
    padding-block: calc(var(--spacing) * 16);
  }
}
.lg\\:py-20 {
  @media (width >= 64rem) {
    padding-block: calc(var(--spacing) * 20);
  }
}
.lg\\:py-28 {
  @media (width >= 64rem) {
    padding-block: calc(var(--spacing) * 28);
  }
}
.lg\\:text-5xl {
  @media (width >= 64rem) {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
}
.lg\\:text-6xl {
  @media (width >= 64rem) {
    font-size: var(--text-6xl);
    line-height: var(--tw-leading, var(--text-6xl--line-height));
  }
}
.\\[\\&_a\\]\\:text-emerald-700 {
  & a {
    color: var(--color-emerald-700);
  }
}
.\\[\\&_a\\]\\:underline {
  & a {
    text-decoration-line: underline;
  }
}
.\\[\\&_a\\]\\:underline-offset-2 {
  & a {
    text-underline-offset: 2px;
  }
}
.hover\\:\\[\\&_a\\]\\:text-emerald-800 {
  &:hover {
    @media (hover: hover) {
      & a {
        color: var(--color-emerald-800);
      }
    }
  }
}
.\\[\\&_blockquote\\]\\:my-4 {
  & blockquote {
    margin-block: calc(var(--spacing) * 4);
  }
}
.\\[\\&_blockquote\\]\\:border-l-4 {
  & blockquote {
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
  }
}
.\\[\\&_blockquote\\]\\:border-\\[\\#C9A227\\] {
  & blockquote {
    border-color: #C9A227;
  }
}
.\\[\\&_blockquote\\]\\:pl-4 {
  & blockquote {
    padding-left: calc(var(--spacing) * 4);
  }
}
.\\[\\&_blockquote\\]\\:text-gray-600 {
  & blockquote {
    color: var(--color-gray-600);
  }
}
.\\[\\&_blockquote\\]\\:italic {
  & blockquote {
    font-style: italic;
  }
}
.\\[\\&_code\\]\\:rounded {
  & code {
    border-radius: 0.25rem;
  }
}
.\\[\\&_code\\]\\:bg-gray-100 {
  & code {
    background-color: var(--color-gray-100);
  }
}
.\\[\\&_code\\]\\:px-1\\.5 {
  & code {
    padding-inline: calc(var(--spacing) * 1.5);
  }
}
.\\[\\&_code\\]\\:py-0\\.5 {
  & code {
    padding-block: calc(var(--spacing) * 0.5);
  }
}
.\\[\\&_code\\]\\:text-sm {
  & code {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
}
.\\[\\&_em\\]\\:italic {
  & em {
    font-style: italic;
  }
}
.\\[\\&_h1\\]\\:mt-8 {
  & h1 {
    margin-top: calc(var(--spacing) * 8);
  }
}
.\\[\\&_h1\\]\\:mb-4 {
  & h1 {
    margin-bottom: calc(var(--spacing) * 4);
  }
}
.\\[\\&_h1\\]\\:font-serif {
  & h1 {
    font-family: var(--font-serif);
  }
}
.\\[\\&_h1\\]\\:text-3xl {
  & h1 {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
}
.\\[\\&_h1\\]\\:font-bold {
  & h1 {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
}
.\\[\\&_h2\\]\\:mt-7 {
  & h2 {
    margin-top: calc(var(--spacing) * 7);
  }
}
.\\[\\&_h2\\]\\:mb-3 {
  & h2 {
    margin-bottom: calc(var(--spacing) * 3);
  }
}
.\\[\\&_h2\\]\\:font-serif {
  & h2 {
    font-family: var(--font-serif);
  }
}
.\\[\\&_h2\\]\\:text-2xl {
  & h2 {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
}
.\\[\\&_h2\\]\\:font-bold {
  & h2 {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
}
.\\[\\&_h3\\]\\:mt-6 {
  & h3 {
    margin-top: calc(var(--spacing) * 6);
  }
}
.\\[\\&_h3\\]\\:mb-2 {
  & h3 {
    margin-bottom: calc(var(--spacing) * 2);
  }
}
.\\[\\&_h3\\]\\:font-serif {
  & h3 {
    font-family: var(--font-serif);
  }
}
.\\[\\&_h3\\]\\:text-xl {
  & h3 {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
}
.\\[\\&_h3\\]\\:font-semibold {
  & h3 {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
}
.\\[\\&_hr\\]\\:my-8 {
  & hr {
    margin-block: calc(var(--spacing) * 8);
  }
}
.\\[\\&_hr\\]\\:border-gray-200 {
  & hr {
    border-color: var(--color-gray-200);
  }
}
.\\[\\&_img\\]\\:my-4 {
  & img {
    margin-block: calc(var(--spacing) * 4);
  }
}
.\\[\\&_img\\]\\:max-w-full {
  & img {
    max-width: 100%;
  }
}
.\\[\\&_img\\]\\:rounded-lg {
  & img {
    border-radius: var(--radius-lg);
  }
}
.\\[\\&_li\\]\\:mb-1\\.5 {
  & li {
    margin-bottom: calc(var(--spacing) * 1.5);
  }
}
.\\[\\&_ol\\]\\:mb-4 {
  & ol {
    margin-bottom: calc(var(--spacing) * 4);
  }
}
.\\[\\&_ol\\]\\:ml-6 {
  & ol {
    margin-left: calc(var(--spacing) * 6);
  }
}
.\\[\\&_ol\\]\\:list-decimal {
  & ol {
    list-style-type: decimal;
  }
}
.\\[\\&_p\\]\\:mb-4 {
  & p {
    margin-bottom: calc(var(--spacing) * 4);
  }
}
.\\[\\&_pre\\]\\:my-4 {
  & pre {
    margin-block: calc(var(--spacing) * 4);
  }
}
.\\[\\&_pre\\]\\:overflow-x-auto {
  & pre {
    overflow-x: auto;
  }
}
.\\[\\&_pre\\]\\:rounded-lg {
  & pre {
    border-radius: var(--radius-lg);
  }
}
.\\[\\&_pre\\]\\:bg-gray-100 {
  & pre {
    background-color: var(--color-gray-100);
  }
}
.\\[\\&_pre\\]\\:p-4 {
  & pre {
    padding: calc(var(--spacing) * 4);
  }
}
.\\[\\&_strong\\]\\:font-bold {
  & strong {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
}
.\\[\\&_table\\]\\:my-4 {
  & table {
    margin-block: calc(var(--spacing) * 4);
  }
}
.\\[\\&_table\\]\\:w-full {
  & table {
    width: 100%;
  }
}
.\\[\\&_td\\]\\:border-b {
  & td {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
}
.\\[\\&_td\\]\\:border-gray-100 {
  & td {
    border-color: var(--color-gray-100);
  }
}
.\\[\\&_td\\]\\:p-2 {
  & td {
    padding: calc(var(--spacing) * 2);
  }
}
.\\[\\&_th\\]\\:border-b-2 {
  & th {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
}
.\\[\\&_th\\]\\:border-gray-200 {
  & th {
    border-color: var(--color-gray-200);
  }
}
.\\[\\&_th\\]\\:p-2 {
  & th {
    padding: calc(var(--spacing) * 2);
  }
}
.\\[\\&_th\\]\\:text-left {
  & th {
    text-align: left;
  }
}
.\\[\\&_ul\\]\\:mb-4 {
  & ul {
    margin-bottom: calc(var(--spacing) * 4);
  }
}
.\\[\\&_ul\\]\\:ml-6 {
  & ul {
    margin-left: calc(var(--spacing) * 6);
  }
}
.\\[\\&_ul\\]\\:list-disc {
  & ul {
    list-style-type: disc;
  }
}
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-serif: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-amber-50: oklch(98.7% 0.022 95.277);
    --color-amber-100: oklch(96.2% 0.059 95.617);
    --color-amber-600: oklch(66.6% 0.179 58.318);
    --color-amber-700: oklch(55.5% 0.163 48.998);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-emerald-50: oklch(97.9% 0.021 166.113);
    --color-emerald-100: oklch(95% 0.052 163.051);
    --color-emerald-200: oklch(90.5% 0.093 164.15);
    --color-emerald-300: oklch(84.5% 0.143 164.978);
    --color-emerald-400: oklch(76.5% 0.177 163.223);
    --color-emerald-500: oklch(69.6% 0.17 162.48);
    --color-emerald-600: oklch(59.6% 0.145 163.225);
    --color-emerald-700: oklch(50.8% 0.118 165.612);
    --color-emerald-800: oklch(43.2% 0.095 166.913);
    --color-emerald-900: oklch(37.8% 0.077 168.94);
    --color-blue-50: oklch(97% 0.014 254.604);
    --color-blue-200: oklch(88.2% 0.059 254.128);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-gray-950: oklch(13% 0.028 261.692);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-4xl: 56rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --text-6xl: 3.75rem;
    --text-6xl--line-height: 1;
    --font-weight-light: 300;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-tight: 1.25;
    --leading-relaxed: 1.625;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);
    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-sm: 8px;
    --blur-md: 12px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities;
@layer base {
  :root {
    --font-serif: 'Playfair Display', Georgia, serif;
    --font-sans: 'Inter', system-ui, -apple-system, sans-serif;
    --color-gold: #c9a227;
    --color-gold-light: #d4af37;
    --color-gold-dark: #b8860b;
    --color-cream: #f7f1ec;
    --color-emerald: #047857;
    --color-emerald-dark: #065f46;
  }
  html {
    font-family: var(--font-sans);
    font-size: 16px;
    line-height: 1.7;
  }
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--font-serif);
    line-height: 1.2;
  }
}
@layer components {
  .font-serif {
    font-family: var(--font-serif);
  }
  .font-sans {
    font-family: var(--font-sans);
  }
  .text-gold {
    color: var(--color-gold);
  }
  .bg-gold {
    background-color: var(--color-gold);
  }
  .border-gold {
    border-color: var(--color-gold);
  }
  .hover\\:bg-gold-dark:hover {
    background-color: var(--color-gold-dark);
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./src/styles/main.css","webpack://./node_modules/tailwindcss/index.css"],"names":[],"mappings":"AAAA,iEAAA;ACEA,iBAAoB;AAApB;EAAA,oBAAoB;AAAA;AAApB;EAAA,kBAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,kBAAoB;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,kCAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,kCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,wBAAoB;AAAA;AAApB;EAAA,WAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,QAAoB;AAAA;AAApB;EAAA,QAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;AAAA;AAApB;EAAA,mBAAoB;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,4BAAoB;EAApB,qBAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,4BAAoB;EAApB,qBAAoB;AAAA;AAApB;EAAA,cAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,qBAAoB;AAAA;AAApB;EAAA,oBAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,kCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,kCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,kBAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,WAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,OAAoB;AAAA;AAApB;EAAA,cAAoB;AAAA;AAApB;EAAA,+CAAoB;EAApB,sDAAoB;AAAA;AAApB;EAAA,0CAAoB;EAApB,sDAAoB;AAAA;AAApB;EAAA,0CAAoB;EAApB,sDAAoB;AAAA;AAApB;EAAA,0CAAoB;EAApB,sDAAoB;AAAA;AAApB;EAAA,0CAAoB;EAApB,sDAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,0GAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,qBAAoB;AAAA;AAApB;EAAA,gDAAoB;AAAA;AAApB;EAAA,gDAAoB;AAAA;AAApB;EAAA,sBAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,mBAAoB;AAAA;AAApB;EAAA,qBAAoB;AAAA;AAApB;EAAA,uBAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,uBAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA;IAAA,uBAAoB;IAApB,8EAAoB;IAApB,sFAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uBAAoB;IAApB,8EAAoB;IAApB,sFAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uBAAoB;IAApB,8EAAoB;IAApB,sFAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uBAAoB;IAApB,8EAAoB;IAApB,sFAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uBAAoB;IAApB,8EAAoB;IAApB,sFAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uBAAoB;IAApB,8EAAoB;IAApB,sFAAoB;EAAA;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA,sBAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,mBAAoB;AAAA;AAApB;EAAA,mBAAoB;AAAA;AAApB;EAAA,mCAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,oCAAoB;EAApB,iBAAoB;AAAA;AAApB;EAAA,oCAAoB;EAApB,iBAAoB;AAAA;AAApB;EAAA,wCAAoB;EAApB,qBAAoB;AAAA;AAApB;EAAA,2CAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,mCAAoB;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,4EAAoB;EAApB;IAAA,4EAAoB;EAAA;AAAA;AAApB;EAAA,mCAAoB;AAAA;AAApB;EAAA,mCAAoB;AAAA;AAApB;EAAA,mCAAoB;AAAA;AAApB;EAAA,kCAAoB;AAAA;AAApB;EAAA,gCAAoB;AAAA;AAApB;EAAA,uDAAoB;EAApB;IAAA,sEAAoB;EAAA;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,+DAAoB;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,2DAAoB;EAApB;IAAA,0EAAoB;EAAA;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,yCAAoB;AAAA;AAApB;EAAA,0CAAoB;AAAA;AAApB;EAAA,0CAAoB;AAAA;AAApB;EAAA,iFAAoB;EAApB;IAAA,gFAAoB;EAAA;AAAA;AAApB;EAAA,iFAAoB;EAApB;IAAA,gFAAoB;EAAA;AAAA;AAApB;EAAA,0CAAoB;AAAA;AAApB;EAAA,0CAAoB;AAAA;AAApB;EAAA,0CAAoB;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,oCAAoB;AAAA;AAApB;EAAA,0DAAoB;EAApB;IAAA,yEAAoB;EAAA;AAAA;AAApB;EAAA,2DAAoB;EAApB;IAAA,0EAAoB;EAAA;AAAA;AAApB;EAAA,2DAAoB;EAApB;IAAA,0EAAoB;EAAA;AAAA;AAApB;EAAA,2DAAoB;EAApB;IAAA,0EAAoB;EAAA;AAAA;AAApB;EAAA,2DAAoB;EAApB;IAAA,0EAAoB;EAAA;AAAA;AAApB;EAAA,0CAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,gDAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,yCAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,uCAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,6DAAoB;EAApB;IAAA,4EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,6DAAoB;EAApB;IAAA,4EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,6DAAoB;EAApB;IAAA,4EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,6DAAoB;EAApB;IAAA,4EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,6DAAoB;EAApB;IAAA,4EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,2CAAoB;EAApB,8LAAoB;AAAA;AAApB;EAAA,4CAAoB;EAApB,8LAAoB;AAAA;AAApB;EAAA,4CAAoB;EAApB,8LAAoB;AAAA;AAApB;EAAA,4DAAoB;EAApB;IAAA,2EAAoB;EAAA;EAApB,4NAAoB;EAApB,iDAAoB;AAAA;AAApB;EAAA,4DAAoB;EAApB;IAAA,2EAAoB;EAAA;EAApB,4NAAoB;EAApB,iDAAoB;AAAA;AAApB;EAAA,4DAAoB;EAApB;IAAA,2EAAoB;EAAA;EAApB,4NAAoB;EAApB,iDAAoB;AAAA;AAApB;EAAA,4DAAoB;EAApB;IAAA,2EAAoB;EAAA;EAApB,4NAAoB;EAApB,iDAAoB;AAAA;AAApB;EAAA,2CAAoB;EAApB,4NAAoB;EAApB,iDAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,4NAAoB;EAApB,iDAAoB;AAAA;AAApB;EAAA,2DAAoB;EAApB;IAAA,0EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,2DAAoB;EAApB;IAAA,0EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,yCAAoB;EAApB,8LAAoB;AAAA;AAApB;EAAA,iFAAoB;EAApB;IAAA,+EAAoB;EAAA;EAApB,8LAAoB;AAAA;AAApB;EAAA,0CAAoB;EAApB,8LAAoB;AAAA;AAApB;EAAA,uCAAoB;EAApB,8LAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,8LAAoB;AAAA;AAApB;EAAA,iBAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,iCAAoB;AAAA;AAApB;EAAA,kCAAoB;AAAA;AAApB;EAAA,0CAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,yCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,yCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,yCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,qCAAoB;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,uCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,wCAAoB;AAAA;AAApB;EAAA,yCAAoB;AAAA;AAApB;EAAA,sCAAoB;AAAA;AAApB;EAAA,kBAAoB;AAAA;AAApB;EAAA,gBAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,8BAAoB;AAAA;AAApB;EAAA,0BAAoB;EAApB,4DAAoB;AAAA;AAApB;EAAA,0BAAoB;EAApB,4DAAoB;AAAA;AAApB;EAAA,0BAAoB;EAApB,4DAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB,6DAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,2DAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,eAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,oCAAoB;EAApB,mCAAoB;AAAA;AAApB;EAAA,kCAAoB;EAApB,iCAAoB;AAAA;AAApB;EAAA,yCAAoB;EAApB,oCAAoB;AAAA;AAApB;EAAA,0CAAoB;EAApB,qCAAoB;AAAA;AAApB;EAAA,2CAAoB;EAApB,sCAAoB;AAAA;AAApB;EAAA,6CAAoB;EAApB,wCAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;AAAA;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,mCAAoB;EAApB,oCAAoB;AAAA;AAApB;EAAA,oCAAoB;EAApB,qCAAoB;AAAA;AAApB;EAAA,qCAAoB;EAApB,sCAAoB;AAAA;AAApB;EAAA,cAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,6BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,4BAAoB;AAAA;AAApB;EAAA,2BAAoB;AAAA;AAApB;EAAA,2BAAoB;AAAA;AAApB;EAAA,2BAAoB;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,gDAAoB;EAApB;IAAA,+DAAoB;EAAA;AAAA;AAApB;EAAA,gDAAoB;EAApB;IAAA,+DAAoB;EAAA;AAAA;AAApB;EAAA,yBAAoB;AAAA;AAApB;EAAA,+BAAoB;AAAA;AAApB;EAAA,+CAAoB;AAAA;AAApB;EAAA,0BAAoB;AAAA;AAApB;EAAA,0BAAoB;AAAA;AAApB;EAAA,WAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,YAAoB;AAAA;AAApB;EAAA,aAAoB;AAAA;AAApB;EAAA,wEAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,sEAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,uEAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,uEAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,sEAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,uEAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,+HAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,6HAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,gIAAoB;EAApB,sIAAoB;AAAA;AAApB;EAAA,+DAAoB;EAApB;IAAA,yHAAoB;EAAA;AAAA;AAApB;EAAA,kFAAoB;EAApB;IAAA,0IAAoB;EAAA;AAAA;AAApB;EAAA,kFAAoB;EAApB;IAAA,0IAAoB;EAAA;AAAA;AAApB;EAAA,0FAAoB;EAApB,4CAAoB;EAApB,0LAAoB;AAAA;AAApB;EAAA,4FAAoB;EAApB,oDAAoB;EAApB,0LAAoB;AAAA;AAApB;EAAA,4FAAoB;EAApB,oDAAoB;EAApB,0LAAoB;AAAA;AAApB;EAAA,wCAAoB;EAApB,gRAAoB;AAAA;AAApB;EAAA,wCAAoB;EAApB,gRAAoB;AAAA;AAApB;EAAA,gTAAoB;EAApB,qFAAoB;EAApB,2EAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,qFAAoB;EAApB,2EAAoB;AAAA;AAApB;EAAA,uKAAoB;EAApB,qFAAoB;EAApB,2EAAoB;AAAA;AAApB;EAAA,wDAAoB;EAApB,qFAAoB;EAApB,2EAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,0BAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,0BAAoB;AAAA;AAApB;EAAA,oBAAoB;EAApB,0BAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,8CAAoB;AAAA;AAApB;EAAA;IAAA;MAAA,kBAAoB;MAApB,kBAAoB;MAApB,kBAAoB;MAApB,0CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,kBAAoB;MAApB,kBAAoB;MAApB,kBAAoB;MAApB,0CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,WAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,WAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,0CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,oCAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,cAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA,2CAAoB;IAApB,wBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,0CAAoB;MAApB,sDAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,6CAAoB;MAApB,sDAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,2CAAoB;MAApB,sDAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,kBAAoB;MAApB,kBAAoB;MAApB,kBAAoB;MAApB,0CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,mCAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,yBAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,yBAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,yBAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,yCAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,0CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,0CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,0CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,sCAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,uCAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,oCAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,4CAAoB;MAApB,8LAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,yCAAoB;MAApB,8LAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,cAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,cAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,6BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,4BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,4BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,2BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,yBAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+BAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+CAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,aAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,sEAAoB;MAApB,sIAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+HAAoB;MAApB,sIAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,gIAAoB;MAApB,sIAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA,+DAAoB;MAApB;QAAA,yHAAoB;MAAA;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,oCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wHAAoB;IAApB,sIAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8EAAoB;IAApB;MAAA,+EAAoB;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA,wBAAoB;IAApB,mBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wHAAoB;IAApB,sIAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,2BAAoB;IAApB,4GAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wBAAoB;IAApB,mBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,mBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,YAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,YAAoB;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA;QAAA,0CAAoB;QAApB,sDAAoB;MAAA;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA,eAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,mBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,mBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,iCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,iCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,QAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,QAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,4BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,4BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,+BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,iDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,6BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,kCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,kCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,kCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,2BAAoB;IAApB,6DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,eAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,eAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,eAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,eAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,eAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,QAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,QAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,4BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,4BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,aAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,aAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,iDAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,+BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,+BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA;MAAA;QAAA,+BAAoB;MAAA;IAAA;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;IAApB,sBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,qBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,4BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,kBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,sBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0CAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,kBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,oCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;IAApB,oCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,oCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;IAApB,oCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,oCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,8BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,6CAAoB;IAApB,wCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,mCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,eAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,+BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,qCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,wBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,+BAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,iCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,yCAAoB;IAApB,oCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,sCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,WAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,2CAAoB;IAApB,wBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,mCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,iCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,2CAAoB;IAApB,wBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,mCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,iCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,gBAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,uCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,qCAAoB;EAAA;AAAA;AAApB;EAAA;IAAA,qBAAoB;EAAA;AAAA;ACFpB,yCAAyC;AAEzC;EACE;IACE;6DAEyD;IACzD,yEAAyE;IACzE;8BAE0B;IAE1B,wCAAwC;IAExC,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAgB1C,2CAA2C;IAC3C,4CAA4C;IAK5C,4CAA4C;IAC5C,4CAA4C;IAE5C,4CAA4C;IAuC5C,8CAA8C;IAC9C,6CAA6C;IAC7C,8CAA8C;IAC9C,+CAA+C;IAC/C,+CAA+C;IAC/C,6CAA6C;IAC7C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,8CAA8C;IAuC9C,yCAAyC;IAEzC,4CAA4C;IAG5C,4CAA4C;IA2F5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,0CAA0C;IAC1C,0CAA0C;IAsF1C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAalB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAGtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAU1B,wBAAwB;IAExB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAOvB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IAExB,qBAAqB;IAGrB,wBAAwB;IAMxB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IAoBpB,6CAA6C;IAC7C,6CAA6C;IAkB7C,2CAA2C;IAE3C,uCAAuC;IAEvC,+DAA+D;IAqC/D,cAAc;IACd,eAAe;IAcf,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;EA5f5C;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IAEE,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IAEd,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ,gBAAiB;ADv6BjB;EACE;IAEE,gDAAiD;IACjD,0DAA2D;IAG3D,qBAAsB;IACtB,2BAA4B;IAC5B,0BAA2B;IAC3B,sBAAuB;IACvB,wBAAyB;IACzB,6BAA8B;EAC/B;EAED;IACE,6BAA8B;IAC9B,eAAgB;IAChB,gBAAiB;EAClB;EAED;IACE,mCAAoC;IACpC,kCAAmC;EACpC;EAED;;;;;;IAME,8BAA+B;IAC/B,gBAAiB;EAClB;AACF;AAED;EACE;IACE,8BAA+B;EAChC;EAED;IACE,6BAA8B;EAC/B;EAGD;IACE,wBAAyB;EAC1B;EAED;IACE,mCAAoC;EACrC;EAED;IACE,+BAAgC;EACjC;EAED;IACE,wCAAyC;EAC1C;AACF;AAlED;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,iBAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;ACichB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AD/crB;EAAA;IAAA;MAAA,mBAAoB;MAApB,mBAAoB;MAApB,mBAAoB;MAApB,sBAAoB;MAApB,sBAAoB;MAApB,sBAAoB;MAApB,oBAAoB;MAApB,oBAAoB;MAApB,uBAAoB;MAApB,wBAAoB;MAApB,+BAAoB;MAApB,yBAAoB;MAApB,wBAAoB;MAApB,uBAAoB;MAApB,4BAAoB;MAApB,gCAAoB;MAApB,+BAAoB;MAApB,+BAAoB;MAApB,+BAAoB;MAApB,qBAAoB;MAApB,yBAAoB;MAApB,sBAAoB;MAApB,sBAAoB;MAApB,0BAAoB;MAApB,uBAAoB;MAApB,4BAAoB;MAApB,gCAAoB;MAApB,6BAAoB;MAApB,wBAAoB;MAApB,2BAAoB;MAApB,8BAAoB;MAApB,iCAAoB;MAApB,wBAAoB;MAApB,2BAAoB;MAApB,4BAAoB;MAApB,kCAAoB;MAApB,kBAAoB;MAApB,wBAAoB;MAApB,sBAAoB;MAApB,uBAAoB;MAApB,wBAAoB;MAApB,oBAAoB;MAApB,qBAAoB;MAApB,sBAAoB;MAApB,mBAAoB;MAApB,yBAAoB;MAApB,+BAAoB;MAApB,4BAAoB;MAApB,8BAAoB;MAApB,2BAAoB;MAApB,iCAAoB;MAApB,+BAAoB;MAApB,gCAAoB;MAApB,iCAAoB;MAApB,6BAAoB;MAApB,8BAAoB;MAApB,+BAAoB;MAApB,4BAAoB;MAApB,sBAAoB;MAApB,kBAAoB;MAApB,eAAoB;MAApB,eAAoB;MAApB,eAAoB;IAAA;EAAA;AAAA","sourcesContent":[null,"@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import 'tailwindcss';\n\n@layer base {\n  :root {\n    /* Typography */\n    --font-serif: 'Playfair Display', Georgia, serif;\n    --font-sans: 'Inter', system-ui, -apple-system, sans-serif;\n\n    /* Colours */\n    --color-gold: #c9a227;\n    --color-gold-light: #d4af37;\n    --color-gold-dark: #b8860b;\n    --color-cream: #f7f1ec;\n    --color-emerald: #047857;\n    --color-emerald-dark: #065f46;\n  }\n\n  html {\n    font-family: var(--font-sans);\n    font-size: 16px;\n    line-height: 1.7;\n  }\n\n  body {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: var(--font-serif);\n    line-height: 1.2;\n  }\n}\n\n@layer components {\n  .font-serif {\n    font-family: var(--font-serif);\n  }\n\n  .font-sans {\n    font-family: var(--font-sans);\n  }\n\n  /* Gold accent utilities */\n  .text-gold {\n    color: var(--color-gold);\n  }\n\n  .bg-gold {\n    background-color: var(--color-gold);\n  }\n\n  .border-gold {\n    border-color: var(--color-gold);\n  }\n\n  .hover\\:bg-gold-dark:hover {\n    background-color: var(--color-gold-dark);\n  }\n}\n","@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
